import { APIResult } from '@shared/Frontend/utils/apiResult'
import { AsyncState } from 'ballerina-core'

export type MonadsTestState = AsyncState<PictureAPIResponse>

export type PictureAPIResponse = APIResult<PictureWithFlags[]>

export interface PictureWithFlags {
  id: string
  url: string
  width: number
  height: number
  breeds: [{ flag: string }]
}

export const initialMonadsTestState: MonadsTestState = AsyncState.Default.unloaded()
